import { ReactComponent as SvgPin } from '@img/icons/location-icon.svg';
import { ReactComponent as SvgExternalLink } from '@img/icons/share-icon.svg';
import { ReactComponent as SvgLeaf } from '@img/icons/sustainability-leaf.svg';
import { ReactComponent as SvgPhone } from '@img/icons/telephone-icon.svg';
import React from 'react';
import S from './HTAMemberCard.styles';
import LinkButton from '@stories/Components/Buttons/LinkButton/LinkButton';
export var SustainabilityStatus;
(function (SustainabilityStatus) {
    SustainabilityStatus["full"] = "Full";
    SustainabilityStatus["provisional"] = "Provisional";
})(SustainabilityStatus || (SustainabilityStatus = {}));
const MemberCard = ({ address, content, phone, name, sustainabilityStatus, sustainabilityLink, tags, website, url, showButton = false, }) => {
    return (React.createElement(S.Container, null,
        React.createElement(S.ContentWrapper, null,
            url ? (React.createElement(S.TitleLink, { href: url, target: "_self" },
                React.createElement(S.Title, null, name))) : (React.createElement(S.Title, null, name)),
            address && (React.createElement(S.DetailItem, null,
                React.createElement(S.DetailIcon, { as: SvgPin }),
                React.createElement(S.DetailText, null, address))),
            phone && (React.createElement(S.DetailItem, { as: "a", href: `tel:${phone}` },
                React.createElement(S.DetailIcon, { as: SvgPhone }),
                React.createElement(S.DetailText, null, phone))),
            website && (React.createElement(S.DetailItem, { as: "a", href: website, target: "_blank", rel: "noopener noreferrer" },
                React.createElement(S.DetailIcon, { as: SvgExternalLink }),
                React.createElement(S.DetailText, null, "Visit Website"))),
            sustainabilityStatus && (React.createElement(S.DetailItem, { ...(sustainabilityLink
                    ? { as: 'a', href: sustainabilityLink, target: '_blank', rel: 'noopener noreferrer' }
                    : {}) },
                React.createElement(S.DetailIcon, { as: SvgLeaf }),
                React.createElement(S.DetailText, null,
                    "Sustainability Roadmap Supporter - ",
                    sustainabilityStatus))),
            content && (React.createElement(React.Fragment, null,
                React.createElement(S.Separator, null),
                React.createElement(S.Content, null, content))),
            tags && tags.length > 0 && (React.createElement(React.Fragment, null,
                React.createElement(S.Separator, null),
                React.createElement(S.TagList, null, tags.map((tag, index) => (React.createElement(S.TagItem, { key: `${tag}-${index}` }, tag)))))),
            showButton && url && (React.createElement(S.ButtonContainer, null,
                React.createElement(LinkButton, { title: "View Profile", href: url, themeOption: "aplGreen" }))))));
};
export default MemberCard;
